import {
	Injectable
} from '@angular/core';
import {
	environment
} from 'src/environments/environment';
import {
	ApiService
} from './api.service';
import { CurrentUserService } from '../current-user.service';

@Injectable({ providedIn: 'root' })
export class PmkvycmService {
	logginUser: any;

	constructor(
		private apiService: ApiService,
		private currentServcie: CurrentUserService
	) {
		this._getCurrentUser()
	}

	_getCurrentUser() {
		this.currentServcie.getCurrentUser().subscribe(res => {
			this.logginUser = res;
			// this.getBatchDetails(this.batchId);
		})
	}


	getBatchListForMonitoring(pageNo, limit, filter?) {
		let Url;
		filter = Object.assign({}, filter, {
			'type': 'pmkvy'
		})
		const objJsonB64 = window.btoa(JSON.stringify(filter))
		if (filter) {
			Url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/pmkvy/batchList?query=${objJsonB64}&pageNo=${pageNo}&limit=${limit}`
		} else {
			Url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/pmkvy/batchList?query=${objJsonB64}&pageNo=${pageNo}&limit=${limit}`
		}
		return this.apiService.get(Url)
	}

	getBatchDetail(batchId) {
		const objJsonB64 = window.btoa(JSON.stringify({
			'batchId': Number(batchId)
		}))
		const Url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/pmkvy/batchList?query=${objJsonB64}&projection=no&pageNo=1&limit=1`
		return this.apiService.get(Url)
	}

	getBatchDetailById(batchId) {
		const Url = `${environment.userServiceUrl}/api/batch/v1/batch/${batchId}`
		return this.apiService.get(Url)
	}

	deleteBatchFromCollection(batchId, data) {
		const Url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/ams/deleteBatch/${batchId}`
		return this.apiService.post(Url, data)
	}

	issueShowCauseNotice(data, _id?) {
		let Url;
		this.logginUser.role === 'CMA SPOC' ? Url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/pmkvy/cmaspoc` : Url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/pmkvy/addshowcausetptc/${_id}`;
		return this.apiService.post(Url, data)
	}

	getCommentsOfShowcauseNotice(userRole, pageNo, limit, filter?) {
		let Url;
		if (this.logginUser.role === 'Training Centre' || this.logginUser.role === 'Best In Class Employer' || this.logginUser.role === 'Camps' || this.logginUser.role === 'Employer') {
			Url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/pmkvy/cmworkflow?tcId=${userRole}&issuedByRole=CMA SPOC&pageNo=${pageNo}&limit=${limit}`;
		} else if (this.logginUser.role === 'Training Partner' || this.logginUser.role === 'SSC Scheme Spoc') {
			Url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/pmkvy/cmworkflow?tpId=${userRole}&issuedByRole=CMA SPOC&pageNo=${pageNo}&limit=${limit}`;
		} else if (this.logginUser.role === 'CMA SPOC') {
			Url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/pmkvy/cmworkflow?issuedByRole=${this.logginUser.role}&pageNo=${pageNo}&limit=${limit}`;
		} else {
			Url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/pmkvy/cmworkflow?issuedByRole=${userRole}&pageNo=${pageNo}&limit=${limit}`;
		}
		return this.apiService.get(Url, filter)
	}

	DownloadExcelForCmaSpoc(userRole, pageNo, limit, filter?) {
		let Url;
		if (this.logginUser.role === 'Training Centre' || this.logginUser.role === 'Best In Class Employer' || this.logginUser.role === 'Camps' || this.logginUser.role === 'Employer') {
			Url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/pmkvy/cmworkflowBulkDownloadExcel?tcId=${userRole}&issuedByRole=CMA SPOC&pageNo=${pageNo}&limit=${limit}`;
		} else if (this.logginUser.role === 'Training Partner' || this.logginUser.role === 'SSC Scheme Spoc') {
			Url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/pmkvy/cmworkflowBulkDownloadExcel?tpId=${userRole}&issuedByRole=CMA SPOC&pageNo=${pageNo}&limit=${limit}`;
		} else if (this.logginUser.role === 'CMA SPOC') {
			Url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/pmkvy/cmworkflowBulkDownloadExcel?issuedByRole=${this.logginUser.role}&pageNo=${pageNo}&limit=${limit}`;
		} else {
			Url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/pmkvy/cmworkflowBulkDownloadExcel?issuedByRole=${userRole}&pageNo=${pageNo}&limit=${limit}`;
		}
		return this.apiService.getBlob(Url, 'application/vnd.ms-excel', filter);
	}


	getShowCauseNoticeForBatch(batchId) {
		const Url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/pmkvy/getshowcause/${batchId}`;
		return this.apiService.get(Url)
	}

	getCommentsOfShowcauseNoticeForTp(userRole) {
		const Url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/pmkvy/getshowcause/${userRole}`;
		return this.apiService.get(Url)
	}

	getInprogressBatches(userRole, status, pageNo, limit) {
		const Url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/pmkvy/cmworkflow?issuedByRole=${userRole}&status=${status}&pageNo=${pageNo}&limit=${limit}`;
		return this.apiService.get(Url)
	}

	getCommentsOfShowcauseNoticeForTc(userRole) {
		const Url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/pmkvy/getshowcause/${userRole}`;
		return this.apiService.get(Url)
	}

	DownloadNotice(batchId, ScnId) {
		const Url = `${environment.pdfGenerate}/api/v1/generatepdfreports/showcausenotice/${batchId}/${ScnId}`;
		return this.apiService.get(Url)
	}


	getWorkflowHistroyForCM(data) {
		const Url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/pmkvy/showCauseHistory?`;
		return this.apiService.get(Url, data)
	}


	updateShowCauseNotice(_id, data) {
		const Url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/pmkvy/updateshowcause/${_id}`;
		return this.apiService.put(Url, data)
	}

	cmaHeadTakeActionOnCM(batchId, actionType, req, scnId) {
		const url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/pmkvy/cmaaction/${actionType}/${batchId}/${scnId}`;
		return this.apiService.post(url, req);
	}

	// PMKVY project details
	getPmkvyRevokeProjectDetailsForSttAndSp(tpId, projectId, tcId, schemeType, scnId?) {
		const query = {
			tpId: tpId,
			projectId: projectId,
			tcId: tcId,
			schemeType: schemeType,
			scnId: scnId
		}
		const url = `${environment.userServiceUrl}/api/user/v1/tc/targets`;
		return this.apiService.get(url, query);
	}

	getPmkvyRevokeProjectDetailsForRpl(tpId, projectId, tcId, scnId?) {
		const query = {
			tpId: tpId,
			projectId: projectId,
			tcId: tcId,
			scnId: scnId
		}
		const url = `${environment.userServiceUrl}/api/user/v1/rpl/tc/targets`;
		return this.apiService.get(url, query);
	}

	approvePmkvyRevockedTargetProject(data) {
		const url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/cm/approveTargetRevocation`;
		return this.apiService.post(url, data);
	}

	rejectRevockedTarget(data) {
		const url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/cm/rejectTargetRevocation`;
		return this.apiService.post(url, data);
	}

	approvePmkvyRevockedTargetProjectForProjectUpdate(data) {
		const url = `${environment.userServiceUrl}/api/user/v1/targetrevocation/request`;
		return this.apiService.post(url, data);
	}

	// get Location & jobrole for project
	getJobroleLocationInfoProject(tpId, projecId, tcId, schemeType, scnId) {
		const query = {
			tpId: tpId,
			projectId: projecId,
			tcId: tcId,
			schemeType: schemeType,
			scnId: scnId
		};
		const url = `${environment.userServiceUrl}/api/user/v1/project/jobroles`;
		return this.apiService.get(url, query);
	}

	// get cc Emails For Show cause notice
	getCCEmailsForSCN() {
		const url = `${environment.pmkvycmServiceUrl}/api/v2/batchservice/cm/scnccemails`;
		return this.apiService.get(url);
	}
}
